import React, {useState, useEffect} from 'react'
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import Button from "@material-ui/core/Button";
import Error from "./Error";
import {ThemeProvider} from "@material-ui/styles";
import {useLocation, useHistory} from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import ErrorIcon from '@material-ui/icons/Error';
import green from "@material-ui/core/colors/green";
import DoneIcon from '@material-ui/icons/Done';
import Captcha from "./Captcha";
import FileLoaded from "./FileLoaded";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import {CallFormWinterSoldier, infoArrive} from '../../helper/HelperFunctions'
import {FormControl, FormHelperText, InputLabel, MenuItem, Select} from "@material-ui/core";
import { FORM_URL } from '../../constants'
import AccountDeletion from '../AccountDeletion'

const theme = createMuiTheme({
    typography: {
        fontFamily: [
            '"Lato"',
            '"Roboto"',
            'sans-serif'
        ].join(','),
    },
    palette: {
        primary: {
            main: '#28C339'
        },
        secondary: {
            main: '#aaa'
        }
    },
});

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1),
            width: '90%',
            maxWidth: '600px',
        },
    },
    buttonSend: {
        padding: '6px',
        margin: '15px 12px',
        maxWidth: '500px',
        width: '82vw'
    },
    input: {
        display: 'none',
    },
    uploadButton: {
        width: '88%',
        height: '80px',
        margin: '0px 12px',
        color: '#28C339',
        borderColor: '#28C339',
        marginTop: 20,
    },
    containerFormMobile: {
        backgroundColor: 'white',
        padding: '20px',
        marginTop: '10px'
    },
    containerForm: {
        backgroundColor: 'white',
        padding: '20px',
        borderTop: 'solid 4px #00c121',
        borderBottom: 'solid 4px #00c121',
        marginBottom: '50px',
        paddingBottom: '30px',
        marginTop: '10px'
    },
    responseContainer: {
        padding: 32,
        display: 'flex',
        marginTop: '20vh',
        marginLeft: 'auto',
        marginRight: 'auto',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        backgroundColor: 'transparent',
        width: 320,
        maxWidth: '600px',
    },
    typography: {
        color: '#cc3340',
        position: 'relative',
        top: '-5px',
        display: 'inline',
        paddingLeft: '10px'
    },
    errorIcon: {
        display: 'inline',
        color: '#cc3340'
    },
    rootError: {
        marginTop: '0px',
        marginBottom: '15px',
        border: '1px solid #e35b66',
        borderRadius: '5px',
        height: '25px',
        backgroundColor: '#fff0f1',
        paddingLeft: '10px',
        width: '87%',
        maxWidth: '600px',
        marginLeft: theme.spacing(1),
    },
    iconFailure: {
        color: '#00c121',
        fontSize: 120,
        marginTop: -10
    },
    title: {
        color: 'black',
        fontWeight: 'normal',
        textAlign: 'center'
    },
    text: {
        color: 'dimgrey',
        fontSize: 14,
        textAlign: 'center',
        marginBottom: 24
    },
    loadingContainer: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        background: 'white',
        padding: 16,
        marginTop: 80,
        marginBottom: 80,
        [theme.breakpoints.up(480)]: {
            width: 460
        },
        [theme.breakpoints.up(1024)]: {
            marginTop: 64
        },
    },
    recaptcha: {
        marginTop: '10px',
        maxWidth: '80%'
    },
    selectedButton: {
        color: "white",
        backgroundColor: "#28C339",
        "&:active, &:hover":{
            backgroundColor: "#28C339",
        }
    },
    acceptMessage: {
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        backgroundColor: 'floralwhite',
        margin: '16px 0',
        width: 320
    },
    titleTheme: {
        color: 'black',
        fontWeight: 'normal',
        margin: '10px auto'
    }
}));

const Form = ({isMobile}) => {
    const classes = useStyles();

    const [formJson, setFormJson] = useState([]);
    const [formFieldsJson, setFormFieldsJson] = useState([]);
    const [tagZendeskJson, setTagZendeskJson] = useState([]);

    const [formType, setFormType] = useState('');
    const [search, setSearch] = useState({})
    const [targetNameRequired, setTargetNameRequired] = useState([])
    const [sendInfo, setSendInfo] = useState({
        comment: {
            body: {}
        },
        images: [{
            name: '',
            file: ''
        }],
        subject: '',
        tags: []
    })
    const [error, setError] = useState(true)
    const [arrayErrorMessage, setArrayErrorMessage] = useState({})
    const [idFormType, setIdFormType] = useState(null)
    const [docsRequired, setDocsRequired] = useState(null)
    const [formFields, setFormFields] = useState(null)
    const [toArrayIdFormField, setToArrayIdFormField] = useState([])
    const [tagZendeskRow, setTagZendeskRow] = useState([])
    const [files, setFiles] = useState([])
    const [isMandatoryAttachedFile, setIsMandatoryAttachedFile] = useState(true)

    const [ dataSended, setDataSended ]           = useState(false);
    const [ loading, setLoading ]           = useState(false);
    const [ errorSendData, setErrorSendData ]               = useState(false);
    const [ errorCodeSendData, setErrorCodeSendData ]       = useState(0);
    const [ errorMessageSendData, setErrorMessageSendData ] = useState('');
    const [ errorUrl, setErrorUrl] = useState(false)

    const [trySendInfoWithoutCaptcha, setTrySendInfoWithoutCaptcha] = useState(false)
    const [trySendInfo, setTrySendInfo] = useState(false)
    const [hiddenFormOnSend, setHiddenFormOnSend] = useState(false)
    const [flagAddEmailAndDescription, setFlagAddEmailAndDescription] = useState(true)
    const [fileAdded, setFileAdded] = useState(true)
    const [fileToBig, setFileToBig] = useState(false)
    const [captchaPasses, setCaptchaPasses] = useState(process.env.NODE_ENV === 'development')
    const [alreadyASkFetch, setAlreadyASkFetch] = useState(true)
    const [isArrayErrorMessageNull, setIsArrayErrorMessageNull] = useState(false)

    const location = useLocation()
    const history = useHistory()

    const url = location.pathname

    useEffect(()=>{
        CallFormWinterSoldier(setFormJson, setFormFieldsJson, setTagZendeskJson, alreadyASkFetch, setAlreadyASkFetch)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(()=>{
        if(idFormType && infoArrive(formJson) && infoArrive(formFieldsJson)){
            const infoForm = formJson.filter( form => form.id === idFormType)[0]
            setDocsRequired(infoForm.docsRequired && infoForm.docsRequired)
            if(!infoForm){
                setErrorUrl(true)
                return
            }
            setFormType(infoForm.label)

            if(infoForm.attachFile.includes('true')){
                setIsMandatoryAttachedFile(true)
            } else {
                setIsMandatoryAttachedFile(false)
            }

            let response = []

            formFieldsJson.forEach(function(row){
                if(row.id.length<2){
                    row.id = row.id.split('')
                } else {
                    row.id = row.id.split(', ')
                }
                response.push(row)
            })
            setToArrayIdFormField(response)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formJson, formFieldsJson])

    useEffect(()=>{
        if(url){
            setIdFormType(url.slice((url.lastIndexOf('/')+1)))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idFormType, location])

    useEffect(()=>{
        if (!formType || !tagZendeskJson.length) return;
            const zendeskInfo = tagZendeskJson?.find((tags) => tags?.title === formType) ?? {};
            setTagZendeskRow(() => [zendeskInfo]);
    }, [formType, tagZendeskJson])

    useEffect(()=>{
        if(idFormType){
            setFormFields(toArrayIdFormField.filter( form => form.id.includes(idFormType)))
        }
    }, [toArrayIdFormField, idFormType])
    
    useEffect(()=>{
        if(formFields!== null){
            getInputTargetName()
            setFlagAddEmailAndDescription(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formFields])

    const getInputTargetName = () => {
        if(flagAddEmailAndDescription){
            setTargetNameRequired( targetNameRequired => [
                ...targetNameRequired,
                'email',
            ])
            setTargetNameRequired( targetNameRequired => [
                ...targetNameRequired,
                'description'
            ])
        }
        if(formFields.length!==0){
            formFields.forEach(function(oneInput) {
                if(oneInput.required === true){
                    setTargetNameRequired( targetNameRequired => [
                        ...targetNameRequired,
                        oneInput.name
                    ])
                }
            })
        }
    }
    const handleChange = e => {
        setSearch({
            ...search,
            [e.target.name]: e.target.value
        })
    }

    const onlyTagsZendesk = () => {
        if(tagZendeskRow){
            let tagsKeys = Object.keys(tagZendeskRow[0])
            let tagsValues = Object.values(tagZendeskRow[0])
            let response = []
            if(tagsKeys.includes('tagOne')){
                response.push(tagsValues[tagsKeys.indexOf('tagOne')])
            }
            if(tagsKeys.includes('tagTwo')){
                response.push(tagsValues[tagsKeys.indexOf('tagTwo')])
            }
            if(tagsKeys.includes('tagThree')){
                response.push(tagsValues[tagsKeys.indexOf('tagThree')])
            }
            return response
        }
    }
    const connectToBackend = () => {
        if(error && process.env.NODE_ENV === 'production') return
        //console.log(JSON.stringify(sendInfo))

        const apiUrl = `${FORM_URL}/create`
        const sendFormToTest = (process.env.NODE_ENV === 'production')
        
        fetch(apiUrl, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendInfo)
        }).then(async response => {
                if(response.status === 201 || !sendFormToTest) {
                    console.log(JSON.stringify(sendInfo))
                    setLoading(false);
                    setErrorSendData(false);
                    setDataSended(true)
                } else {
                    console.log(response)
                    setLoading(false);
                    setDataSended(false)
                    setErrorSendData(true);
                    setHiddenFormOnSend(true)
                    setErrorCodeSendData(response.status);
                    setErrorMessageSendData('Error de conexión con base de datos');
                }
        }).catch(error => {
            console.log(error)
            setLoading(false);
            setErrorSendData(true);
            setHiddenFormOnSend(true)
            setErrorCodeSendData(1);
            setErrorMessageSendData(error);
        })
    }

    useEffect(()=>{
        if(sendInfo.length!==0 && sendInfo.tags.length!==0){
            connectToBackend()
        }
        //console.log(JSON.stringify(sendInfo))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sendInfo])

    const chargeInfo = () => {
        setSendInfo({
            comment: {
                body: search
            },
            images: files,
            subject: formType,
            tags: onlyTagsZendesk()
        })

    }

    const createErrorMessage = () => {
        targetNameRequired.forEach(singleNameRequired => {
            if (singleNameRequired==='email'){
                setArrayErrorMessage(arrayErrorMessage => ({...arrayErrorMessage, [singleNameRequired]: `El campo Correo Electrónico no puede estar en blanco`}))
            } else if (singleNameRequired==='description'){
                setArrayErrorMessage(arrayErrorMessage => ({...arrayErrorMessage, [singleNameRequired]: `El campo Descripción no puede estar en blanco`}))
            }

            formFields.find(function(element){
                if(singleNameRequired === element.name){
                    setArrayErrorMessage(arrayErrorMessage => ({...arrayErrorMessage, [singleNameRequired]: `El campo ${element.label} no puede estar en blanco`}))
                }
                return null
            })
            if(Object.keys(search).includes(singleNameRequired) && search[singleNameRequired].trim() !== ''){
                setArrayErrorMessage(arrayErrorMessage => ({...arrayErrorMessage, [singleNameRequired]: null}))
                if(singleNameRequired === 'email' && (!search[singleNameRequired].includes('@') || !search[singleNameRequired].includes('.'))){
                    setArrayErrorMessage(arrayErrorMessage => ({...arrayErrorMessage, [singleNameRequired]: 'Ingrese una casilla de Mail válida'}))
                }
            }
        })
    }

    const searchErrorOnSubmit = () => {
        createErrorMessage()

        setError(true)

        if(Object.keys(search).length === targetNameRequired.length && search.email.trim() !== ''){
            setError(false)
        }
        if(isMandatoryAttachedFile && Object.keys(files).length === 0){
            setFileAdded(false)
        }
    }

    const verifyIfErrorExist = () => {
        for(let i = 0; i < Object.keys(arrayErrorMessage).length; i++){
            if(arrayErrorMessage[i] !== null){
                return false
            }
        }
        return true
    }

    const permitSendInfo = async () => {
        setTrySendInfo(true)
        setIsArrayErrorMessageNull(true)
        let promise = new Promise((resolve) => {
            for(const errorProperty in arrayErrorMessage){
                if(arrayErrorMessage[errorProperty] !== null){
                    setIsArrayErrorMessageNull(true)
                    return
                }
            }
            setTimeout(() => resolve("done"), 500);
        })
        promise.then(()=>{
                if(Object.keys(arrayErrorMessage).length !== 0 && !isArrayErrorMessageNull && verifyIfErrorExist && fileAdded){
                    setError(false)
                    setLoading(true)
                    setHiddenFormOnSend(true)
                    if(captchaPasses){
                        chargeInfo()
                    } else {
                        setTrySendInfoWithoutCaptcha(true)
                    }
                }
            })

        setIsArrayErrorMessageNull(false)
    }

    const onSubmit = e => {
        e.preventDefault()
        searchErrorOnSubmit()
        permitSendInfo()
    }

    useEffect(()=>{
        if(trySendInfo){
            permitSendInfo()
            setTrySendInfo(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trySendInfo])

    const goBackMainPage = () => {
        history.push('/')
    }

    const closeMessage = () => {
        setDataSended(false);
        setLoading(false);
        setErrorSendData(false);
        setHiddenFormOnSend(false)
    }

    const fileChange = e => {
        setFileAdded(true)
        let filesObject = e.target.files
        for(let i = 0; i < filesObject.length; i++){
            if(filesObject[i].size > 5000000){
                setFileToBig(true)
                return
            }
            if(files.find(file => file.name === filesObject[i].name)){
                return
            }
            setFileToBig(false)
            let reader = new FileReader()
            reader.readAsDataURL(filesObject[i])
            let fileName = filesObject[i].name
            reader.onload = (e) => {
                const images = {file: e.target.result}

                setFiles(files => [...files, {
                    name: fileName,
                    file: images.file
                }])
            }
        }
    }
    const selectedClassName = `${classes.buttonSend} ${classes.selectedButton}`

    return (
        <Container maxWidth="sm" className={isMobile ? classes.containerFormMobile : classes.containerForm}>
            <ThemeProvider theme={theme}>
                {
                    errorUrl &&
                        (<Paper data-testid='error-screen' elevation={0} className={classes.responseContainer} style={{ width: '80%' }}>
                            <ErrorIcon className={classes.iconFailure}/>
                            <Typography variant={'h6'} className={classes.titleTheme}>{`ERROR: Path error`}</Typography>
                            <Typography variant={'body2'} className={classes.text}>La página que intentas visitar no se encuentra disponible</Typography>
                            <Typography variant={'body2'} className={classes.text}>Intente ingresando una URL diferente</Typography>
                        </Paper>)
                }
                {
                    !dataSended && !hiddenFormOnSend && !errorUrl &&
                    <form
                        className={classes.root}
                        noValidate autoComplete="off"
                        method="post"
                        action=""
                        encType="multipart/form-data"
                        onSubmit={onSubmit}
                    >
                        <h3 style={{color: theme.palette.secondary}}>{formType}</h3>
                        <div>
                            <TextField
                                id="email"
                                variant="outlined"
                                label="Correo electrónico"
                                name="email"
                                value={search.email ? search.email : ''}
                                onChange={handleChange}
                            />
                            {arrayErrorMessage && Object.keys(arrayErrorMessage).includes('email') && arrayErrorMessage['email'] !== null
                                ? <Error errorMessage={arrayErrorMessage['email']}/>
                                : null
                            }
                            {
                                formFields && formFields.map(function(row, idx){
                                    if (row.helperText === 'null' && row.dateCheckbox === 'false' && row.hourCheckbox === 'false'){
                                        if(arrayErrorMessage && Object.keys(arrayErrorMessage).includes(row.name) && arrayErrorMessage[row.name] !== null) {
                                            return (
                                                <React.Fragment>
                                                    <TextField
                                                        key={idx}
                                                        id={row.name}
                                                        variant="outlined"
                                                        label={row.label}
                                                        name={row.name}
                                                        value={search[row.name]}
                                                        onChange={handleChange}
                                                    />
                                                    <Error errorMessage={arrayErrorMessage[row.name]}/>
                                                </React.Fragment>
                                            )
                                        } else {
                                            return (
                                                <TextField
                                                    key={idx}
                                                    id={row.name}
                                                    variant="outlined"
                                                    label={row.label}
                                                    name={row.name}
                                                    value={search[row.name]}
                                                    onChange={handleChange}
                                                />
                                            )
                                        }
                                    }
                                    else if (row.dateCheckbox === 'true' && row.hourCheckbox === 'false'){
                                        if(arrayErrorMessage && Object.keys(arrayErrorMessage).includes(row.name) && arrayErrorMessage[row.name] !== null) {
                                            return (
                                                <React.Fragment>
                                                    <TextField
                                                        key={idx}
                                                        id={row.name}
                                                        iconFailure
                                                        variant="outlined"
                                                        label={row.label}
                                                        name={row.name}
                                                        type="date"
                                                        defaultValue="2020-08-01"
                                                        value={search[row.name]}
                                                        onChange={handleChange}
                                                        helperText={row.helperText}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    <Error errorMessage={arrayErrorMessage[row.name]}/>
                                                </React.Fragment>
                                            )
                                        } else {
                                            return(
                                                <TextField
                                                    key={idx}
                                                    id={row.name}
                                                    iconFailure
                                                    variant="outlined"
                                                    label={row.label}
                                                    name={row.name}
                                                    type="date"
                                                    defaultValue="2020-08-01"
                                                    value={search[row.name]}
                                                    onChange={handleChange}
                                                    helperText={row.helperText}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            )
                                        }
                                    } else if (row.dateCheckbox === 'false' && row.hourCheckbox === 'true'){
                                        if(arrayErrorMessage && Object.keys(arrayErrorMessage).includes(row.name) && arrayErrorMessage[row.name] !== null){
                                            return(
                                                <React.Fragment>
                                                    <TextField
                                                        key={idx}
                                                        id={row.name}
                                                        variant="outlined"
                                                        label={row.label}
                                                        name={row.name}
                                                        type="time"
                                                        defaultValue="07:30"
                                                        value={search[row.name]}
                                                        onChange={handleChange}
                                                        helperText={row.helperText}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        inputProps={{
                                                            step: 300, // 5 min
                                                        }}
                                                    />
                                                    <Error errorMessage={arrayErrorMessage[row.name]}/>
                                                </React.Fragment>
                                            )
                                        }
                                        else {
                                            return(
                                                <TextField
                                                    key={idx}
                                                    id={row.name}
                                                    variant="outlined"
                                                    label={row.label}
                                                    name={row.name}
                                                    type="time"
                                                    defaultValue="07:30"
                                                    value={search[row.name]}
                                                    onChange={handleChange}
                                                    helperText={row.helperText}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    inputProps={{
                                                        step: 300, // 5 min
                                                    }}
                                                />
                                            )
                                        }
                                    }
                                    else if (row.isSelect === 'true'){
                                        const selectListArray = row.selectList.split(', ')
                                        return(
                                            <>
                                                <FormControl>
                                                    <InputLabel id={row.name} style={{marginLeft: '15px'}}>{row.label}</InputLabel>
                                                    <Select
                                                        key={idx}
                                                        id={row.name}
                                                        labelId={row.name}
                                                        variant="outlined"
                                                        name={row.name}
                                                        value={search[row.name]}
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem value=""> </MenuItem>
                                                        {selectListArray.map(selectItem => <MenuItem value={selectItem}>{selectItem}</MenuItem>)}
                                                    </Select>
                                                    <FormHelperText>{row.helperText}</FormHelperText>
                                                </FormControl>
                                                {
                                                    arrayErrorMessage && Object.keys(arrayErrorMessage).includes(row.name) && arrayErrorMessage[row.name] !== null &&
                                                        <Error errorMessage={arrayErrorMessage[row.name]} style={{width: '100%'}}/>
                                                }
                                            </>
                                        )
                                    }
                                    else {
                                        if(arrayErrorMessage && Object.keys(arrayErrorMessage).includes(row.name) && arrayErrorMessage[row.name] !== null){
                                            return(
                                                <React.Fragment>
                                                    <TextField
                                                        key={idx}
                                                        id={row.name}
                                                        variant="outlined"
                                                        label={row.label}
                                                        name={row.name}
                                                        value={search[row.name]}
                                                        onChange={handleChange}
                                                        helperText={row.helperText}
                                                    />
                                                    <Error errorMessage={arrayErrorMessage[row.name]}/>
                                                </React.Fragment>
                                            )
                                        }
                                        else {
                                            return(
                                                <React.Fragment
                                                    key={idx}
                                                >
                                                    <TextField
                                                        key={idx}
                                                        id={row.name}
                                                        variant="outlined"
                                                        label={row.label}
                                                        name={row.name}
                                                        value={search[row.name]}
                                                        onChange={handleChange}
                                                        helperText={row.helperText}
                                                    />
                                                </React.Fragment>
                                            )
                                        }
                                    }
                                })
                            }
                            <TextField
                                id="description"
                                multiline
                                rows={4}
                                variant="outlined"
                                label="Descripción"
                                name="description"
                                value={search.description}
                                onChange={handleChange}
                                helperText="Ingrese los detalles de su solicitud. Un integrante de nuestro personal de soporte responderá a la brevedad"
                            />
                            {arrayErrorMessage && Object.keys(arrayErrorMessage).includes('description') && arrayErrorMessage['description'] !== null
                                ? <Error errorMessage={arrayErrorMessage['description']}/>
                                : null
                            }

                            <input
                                className={classes.input}
                                id="contained-button-file"
                                multiple
                                accept="image/*, .pdf"
                                name="file"
                                type="file"
                                onChange={fileChange}
                            />
                            <label htmlFor="contained-button-file">
                                <Button variant="outlined" component="span" className={classes.uploadButton}>
                                    Adjuntar archivos
                                </Button>
                            </label>
                            {
                                docsRequired && (
                                    <Typography style={{maxWidth: '85%', textAlign: 'start', marginLeft: 20}} variant={'body2'} className={classes.text}>Para el correcto procesamiento de este formulario, por favor adjunte {docsRequired}</Typography>
                                )
                            }
                            {
                                files && files.length
                                    ? files.map(function(file, idx){
                                        return(
                                            <FileLoaded
                                                key={idx}
                                                files={files}
                                                file={file}
                                                setFiles={setFiles}
                                            />
                                        )
                                    })
                                    : null
                            }
                            {
                                isMandatoryAttachedFile && !fileAdded && <Error errorMessage='Para enviar este formulario, debe adjuntar una imagen'/>
                            }
                            {
                                fileToBig && (
                                    <div className={classes.rootError}>
                                        <ErrorOutlineIcon
                                            className={classes.errorIcon}
                                        />
                                        <p className={classes.typography}>
                                            El archivo no puede ser superior a 5MB
                                        </p>
                                    </div>
                                )
                            }

                        </div>
                        {formType === 'Solicitud de Eliminacion de Cuenta en PAGO46 ' && <AccountDeletion/>}

                        <Captcha
                            setCaptchaPasses={setCaptchaPasses}
                            captchaPasses={captchaPasses}
                        />

                        {
                            !captchaPasses && trySendInfoWithoutCaptcha && (
                                <p style={{color: 'red'}}>Por favor, resuelve el captcha primero</p>
                            )
                        }

                        <Button
                            disabled={!captchaPasses}
                            type="submit"
                            color="primary"
                            variant="outlined"
                            className={captchaPasses ? selectedClassName : classes.buttonSend}
                        > Enviar
                        </Button>

                    </form>
                }

                {
                    loading && captchaPasses && (
                        <Paper data-testid='loading-screen' elevation={0} className={classes.loadingContainer}>
                            <CircularProgress
                                style={{ color: green[500], marginTop: 16, marginLeft: 'auto', marginRight: 'auto' }}
                                thickness={4}
                                size={60}/>
                        </Paper>
                    )
                }
                {
                    errorSendData && !loading && captchaPasses && (
                        <Paper data-testid='error-screen' elevation={0} className={classes.responseContainer} style={{ width: '80%' }}>
                            <ErrorIcon className={classes.iconFailure}/>
                            <Typography variant={'h6'} className={classes.title}>{`ERROR: ${errorCodeSendData}`}</Typography>
                            <Typography variant={'body1'} className={classes.text}>Algo salio mal, por favor vuelve a intentarlo mas tarde.</Typography>
                            <Typography variant={'body2'} className={classes.text}>{`${errorMessageSendData}`}</Typography>
                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                className={classes.buttonSend}
                                onClick={closeMessage}
                            > Volver
                            </Button>
                        </Paper>
                    )
                }
                {
                    dataSended && !error && captchaPasses &&(
                        <Paper data-testid='error-screen' elevation={0} className={classes.acceptMessage} style={{ width: '88%', marginTop: '100px' }}>
                            <DoneIcon className={classes.iconFailure}/>
                            <Typography variant={'h6'} className={classes.title}>Tu mensaje ha sido enviado correctamente</Typography>
                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                className={classes.buttonSend}
                                onClick={goBackMainPage}
                            > Volver
                            </Button>
                        </Paper>
                    )
                }
            </ThemeProvider>
        </Container>
    )
}

export default Form

//https://us-central1-degrees-46.cloudfunctions.net/wintersoldier-sandbox/create
